module.exports = __webpack_public_path__ + "img/09deb5e.png";